import axiosInstance from '../helpers/axiosInstance';

export const getProductGroupsApi = async (request) => {
    const { searchKey = "", pageNo = 0, sizeOfPage = 10, status } = request.params || {};
    let url = `staff/productGroups?searchKey=${encodeURIComponent(searchKey)}&pageNo=${pageNo}&sizeOfPage=${sizeOfPage}`;
    if (status !== undefined && status !== null && status !== "all") {
        url += `&status=${status}`;
    }
    const response = await axiosInstance.get(url);
    return response.data;
};

export const createProductGroupApi = async (request) => {
    const response = await axiosInstance.post('staff/productGroups', request.formData);
    return response.data;
};

export const updateProductGroupApi = async (request) => {
    const response = await axiosInstance.put('staff/productGroups', request.formData);
    return response.data;
};

export const changeProductGroupStatusApi = async (request) => {
    const response = await axiosInstance.put('staff/productGroups/status', request.formData);
    return response.data;
};

export const deleteProductGroupApi = async (request) => {
    const response = await axiosInstance.delete(`staff/productGroups/${request.id}`);
    return response.data;
};

export const getProductGroupDropdownApi = async () => {
    const response = await axiosInstance.get('staff/productGroups/dropdown');
    return response.data;
};

export const assignProductsToSubGroupApi = async (request) => {
    const response = await axiosInstance.post(
        `staff/productSubGroups/${request.subGroupId}/products`,
        { productIds: request.productIds }
    );
    return response.data;
};
